import Rating from '@/components/Common/Rating';
import { CatalogCompany } from '@/shared/types/catalog';
import { getAvgProductionTime } from '@/shared/types/sourcing-marketplace';
import { getFormattedAvgResponseTime } from '@/shared/utils/sourcing-marketplace-util';
import './index.less';

interface SupplierStatsProps {
  supplier: CatalogCompany;
  onReviewLabelClick?: () => void;
}

const SupplierStats = ({ supplier, onReviewLabelClick }: SupplierStatsProps) => {
  const avgProductionTime = getAvgProductionTime(supplier);
  const avgResponseTime = getFormattedAvgResponseTime(supplier);

  return (
    <div className="supplier-stats-box">
      {supplier?.companyReviewScore > 0 && (
        <span className="stat rating">
          <span className="bold">Reviews: </span>
          <Rating
            rate={supplier.companyReviewScore / 2}
            label={`${supplier.companyReviewScore / 2}/5`}
            clickableLabel={`(${supplier.companyReviewCount}+)`}
            onLabelClick={onReviewLabelClick}
          />
        </span>
      )}

      {supplier?.minmoqqty && (
        <span className="stat">
          <span className="bold">MOQ: </span>
          {supplier.minmoqqty ? `${supplier.minmoqqty}+` : 'Inquire'}
        </span>
      )}

      {supplier?.maxsamplecost && supplier?.minsamplecost && (
        <span className="stat">
          <span className="bold">Sampling costs: </span>${supplier.minsamplecost} - ${supplier.maxsamplecost}
        </span>
      )}

      {avgProductionTime && (
        <span className="stat">
          <span className="bold">Avg production time: </span>
          {avgProductionTime}
        </span>
      )}

      {avgResponseTime && (
        <span className="stat">
          <span className="bold">Avg. response time: </span>
          {avgResponseTime}
        </span>
      )}

      {supplier?.country && (
        <span className="stat">
          <span className="bold">Country: </span>
          {supplier.country}
        </span>
      )}
    </div>
  );
};

export default SupplierStats;
